import { useContext } from 'react';
import { FlexContainer, Text, Buttons, Bullets, Modals, ModalContext } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { useTranslation } from 'Hooks/useTranslation';
import { openLinkInNewTab } from 'Utils/links';
import { routes } from 'Constants/routes';
import * as Styled from './styles';
import { SAT_LINK, VIDEO_LINK } from './utils';

const EfirmaInfo = ({ isPayLater }: { isPayLater: boolean }): JSX.Element => {
  const { hideModal } = useContext(ModalContext);
  const { t } = useTranslation(locizeNS.MODALS);

  const handleCloseModal = (): void => {
    hideModal();
  };

  const handleClick = (route: string): void => {
    setTimeout(() => {
      openLinkInNewTab(route);
    }, 100);
  };

  const handleClickNotPayLater = (): void => {
    history.push(routes.PREVIOUS_YEARS_EFIRMA_TYPE_FORM);
    hideModal();
  };

  return (
    <Modals.Centered hasClose maxSize="M" onClose={handleCloseModal}>
      <Styled.Container direction="column">
        <Text type="headline" color="dark" size="S_L_S" align="center" mb="fds_size_24">
          {t('Efirma.modal.title')}
        </Text>
        <Styled.OptionsContainer gap="dimension_08">
          <Text type="paragraphs" color="dark" size="S_M_S" mb="fds_size_08">
            {t('Efirma.modal.subtitle')}
          </Text>
          <FlexContainer direction="column" gap="dimension_08" mb="fds_size_16">
            <Bullets
              bullets={[
                {
                  text: t('Efirma.modal.first.bullet'),
                },
                {
                  text: t('Efirma.modal.second.bullet'),
                },
              ]}
              icon={{
                height: 24,
                type: 'IconTickSolidSGreen',
                width: 24,
              }}
              spacing="M"
            />
            <Bullets
              bullets={[
                {
                  text: t('Efirma.modal.third.bullet'),
                },
              ]}
              icon={{
                height: 24,
                type: 'IconWarningAttentionSolidS',
                width: 24,
              }}
              spacing="M"
            />
          </FlexContainer>
          <Styled.ButtonsContainer direction="column" gap="dimension_08">
            <Buttons.Classic
              mode="primary"
              size="xs"
              label={t('Efirma.modal.button')}
              onClick={() => handleClick(SAT_LINK)}
            />
            {!isPayLater && (
              <Buttons.Tiny label={t('Efirma.typeform.button')} onClick={handleClickNotPayLater} />
            )}
          </Styled.ButtonsContainer>
          <Styled.ContentVideo>
            <Styled.Video src={VIDEO_LINK} title="efirma_video" allowFullScreen />
          </Styled.ContentVideo>
        </Styled.OptionsContainer>
      </Styled.Container>
    </Modals.Centered>
  );
};

export default EfirmaInfo;
